import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { OptionCardProps } from 'LearningManager/constants/createAssignment.constant';
import styles from './OptionCard.module.scss';

const OptionCard: FC<OptionCardProps & { htmlId?: string }> = ({
	selectedId,
	toggleSelect,
	id,
	htmlId,
	icon,
	selectedIcon,
	desc,
	title
}) => {
	const { t } = useTranslation();
	const isSelected = selectedId === id;

	return (
		<div
			id={htmlId}
			className={classNames(styles.card, {
				[styles['card--selected']]: isSelected
			})}
			onClick={() => toggleSelect(id)}
		>
			<div className={styles.label}>
				<div className={styles.iconWrapper}>
					{isSelected ? selectedIcon : icon}
				</div>
				<div className={styles.head}>{t(title)}</div>
			</div>
			<div className={styles.value}>{t(desc)}</div>
		</div>
	);
};

export default OptionCard;
